export default __webpack_public_path__ + "static/media/bg-game.a76d4add.png";